import logo from "./logo.svg";
import thai from "./thai.svg";
import english from "./english.svg";
import add from "./add.svg";
import draft from "./draft.svg";
import UploadCloudBig from "./upload-file.svg";
import profile from "./profile.svg";
import download from "./download.svg";
import password from "./password-check.svg";
import arrowSquareRight from "./arrow-square-right.svg";
import documentText from "./document_text.svg";

// ICONS
import icon1 from "./navbar/icon1.svg";
import icon2 from "./navbar/icon2.svg";
import icon3 from "./navbar/icon3.svg";

import icon5 from "./navbar/icon5.svg";
import icon6 from "./navbar/icon6.svg";
import icon7 from "./navbar/icon7.svg";

import security from "./navbar/security.svg";
import layer from "./navbar/layer.svg";
import money_recive from "./navbar/money-recive.svg";
import wallet_money from "./navbar/wallet-money.svg";
import menu_board from "./navbar/menu-board.svg";
import calendar from "./navbar/calendar.svg";
import clipboard_text from "./navbar/clipboard-text.svg";
import folder2 from "./navbar/folder-2.svg";
import sms_edit from "./navbar/sms-edit.svg";
import folder from "./navbar/folder.svg";
import setting_4 from "./navbar/setting-4.svg";
import document_copy from "./navbar/document-copy.svg";
import document from "./navbar/document.svg";
import brifecase_timer from "./navbar/brifecase-timer.svg";
import star from "./navbar/star.svg";
import people from "./navbar/people.svg";
import video_time from "./navbar/video-time.svg";
import login from "./navbar/login.svg";
import check_in_record from "./check_in_record.svg";
import user_square from "./user-square.svg";
import bag_cross from "./bag-cross.svg";
import edit from "./edit.svg";
import eye from "./eye.svg";
import book_white from "./book-white.svg";
import book_black from "./book-black.svg";
import folder_white from "./folder-white.svg";
import folder_black from "./folder-black.svg";
import folder_2 from "./folder-2.svg";
import folder_3 from "./folder-3.svg";
import advisor from "./navbar/advisor.svg";
import send_2 from "./send-2.svg";
import close_square from "./close-square.svg";
import sms_tracking from "./sms-tracking.svg";
import video_time_white from "./video-time-white.svg";
import tick_square from "./tick-square.svg";
import recovery_convert from "./recovery-convert.svg";
import add_square from "./add-square.svg";
import icon_excel from "./icon_excel.svg";
import icon_pdf from "./icon_pdf.svg";
import download_chat from "./download-chat.svg";
import icon_chat_pdf from "./icon-pdf.png";
import icon_chat_word from "./icon-word.png";
import icon_chat_excel from "./icon-excel.png";

import icon_login_1 from "./icon_login_1.svg";
import icon_login_2 from "./icon_login_2.svg";

import { ReactComponent as SearchNormal } from "./input/search-normal.svg";

import addImage from "./add_image.png";

// ALERT
import successAlert from "./alert/success.svg";
import activeAlert from "./alert/activeAlert.svg";
import errorAlert from "./alert/error.svg";

// SOCIAL
import facebook from "./facebook.svg";
import instagram from "./instagram.svg";
import x from "./x.svg";
import youtube from "./youtube.svg";
//
import excelIcon from "./excel.png";
import wordIcon from "./word.png";
import pdfIcon from "./pdf.png";
import emptyIcon from "./empty.png";

import courseManagementIcon from "./navbar/corse_management.svg";

import facebookIcon from "../icons/button/facebook.png";
import lineIcon from "../icons/button/line.png";
import xIcon from "../icons/button/x.png";
import igIcon from "../icons/button/ig.png";
import youtubeIcon from "../icons/button/youtube.png";

import { ReactComponent as DeleteIcon } from "./delete-bot.svg";
import { ReactComponent as CountFile } from "./count_file.svg";
import { ReactComponent as OpenIcon } from "./open_icon.svg";
import { ReactComponent as UsedIcon } from "./icon_use.svg";
import { ReactComponent as BalanceIcon } from "./balance_icon.svg";
import { ReactComponent as BudgetAllIcon } from "./budget_all.svg";
import { ReactComponent as DashboardIcon } from "./graph.svg";

// ICON COMPONENT
import { ReactComponent as add2 } from "./add.svg";
import { ReactComponent as UploadImageIcon } from "../icons/upload-image-file.svg";
import { ReactComponent as WebsiteIcon } from "./website_structure.svg";
import { ReactComponent as FolderActive } from "../icons/folder-orange.svg";
import { ReactComponent as FolderInActive } from "../icons/folder-gray.svg";
import { ReactComponent as ImageSelectIcon } from "../component/upload-image.svg";
import { ReactComponent as CheckedIcon } from "../icons/checked.svg";
import { ReactComponent as MenuIcon } from "../icons/menu-icon.svg";
import { ReactComponent as MenuIconActive } from "../icons/menu-icon-active.svg";
import { ReactComponent as LinkIcon } from "../icons/link.svg";
import { ReactComponent as FacebookIcon } from "../icons/facebook-contact.svg";
import { ReactComponent as InstagramIcon } from "../icons/instagram-contact.svg";
import { ReactComponent as XIcon } from "../icons/x-contact.svg";
import { ReactComponent as YoutubeIcon } from "../icons/youtube-contact.svg";
import { ReactComponent as LineIcon } from "../icons/line-contact.svg";
import { ReactComponent as HeartIcon } from "../icons/heart.svg";
import { ReactComponent as ViewIcon } from "../icons/view.svg";
import { ReactComponent as SharedIcon } from "../icons/shared.svg";
import { ReactComponent as VdoIcon } from "../icons/video-square.svg";
import { ReactComponent as LinksIcon } from "../icons/links.svg";
import { ReactComponent as UploadImageFileIcon } from "../icons/upload.svg";
import { ReactComponent as SettingIcon } from "../icons/setting.svg";
import { ReactComponent as WebsiteRelatedIcon } from "./website_related.svg";
import { ReactComponent as WebsiteUserCommentIcon } from "./website_user_comments_icon.svg";
import { ReactComponent as SuggestionsIcon } from "./suggestions.svg";
import { ReactComponent as FaqIcon } from "./faq.svg";
import { ReactComponent as HeartSearchIcon } from "./heart_search.svg";

import { ReactComponent as FacebookColorIcon } from "./organization/facebook.svg";
import { ReactComponent as IGColorIcon } from "./organization/ig.svg";
import { ReactComponent as XColorIcon } from "./organization/x.svg";
import { ReactComponent as YoutubeColorIcon } from "./organization/youtube.svg";
import { ReactComponent as HeartNewsIcon } from "../icons/heart.svg";
import { ReactComponent as HeartNewsActiveIcon } from "../icons/heart-active.svg";
import { ReactComponent as EyeIcon } from "../icons/table/eye.svg";
import { ReactComponent as LineColorIcon } from "../icons/line-color-icon.svg";

import { ReactComponent as FlagTh } from "../icons/flagTH.svg";
import { ReactComponent as FlagEn } from "../icons/flagEN.svg";

import { ReactComponent as FilterSearchIcon } from "../icons/filter-search.svg";

// time record system

import { ReactComponent as CoinOne } from "../images/coin_one.svg";
import { ReactComponent as CoinTwo } from "../images/coin_two.svg";
import { ReactComponent as CoinThree } from "../images/coin_three.svg";
import { ReactComponent as CoinFour } from "../images/coin_four.svg";

export const iconsHeader = {
  logo,
  thai,
  english,
};
export const content_icon = {
  facebookIcon,
  lineIcon,
  xIcon,
  igIcon,
  youtubeIcon,
};

export const coin_icons = {
  CoinOne,
  CoinTwo,
  CoinThree,
  CoinFour
}

export const iconsNavbar = {
  icon1,
  icon2,
  icon3,
  icon5,
  icon6,
  icon7,
  sms_edit,
  folder,
  setting_4,
  document_copy,
  brifecase_timer,
  video_time,
  login,
  star,
  people,
  advisor,
  document,
  courseManagementIcon,
  clipboard_text,
  folder2,
  calendar,
  menu_board,
  wallet_money,
  layer,
  money_recive,
  security
};

export const icons = {
  add,
  draft,
  arrowSquareRight,
  UploadCloudBig,
  profile,
  facebook,
  instagram,
  x,
  youtube,
  download,
  password,
  check_in_record,
  user_square,
  icon_login_1,
  icon_login_2,
  bag_cross,
  edit,
  eye,
  book_white,
  book_black,
  folder_white,
  folder_black,
  folder_2,
  folder_3,
  advisor,
  video_time,
  video_time_white,
  send_2,
  sms_edit,
  close_square,
  sms_tracking,
  tick_square,
  recovery_convert,
  add_square,
  icon_excel,
  icon_pdf,
  download_chat,
  icon_chat_pdf,
  icon_chat_word,
  icon_chat_excel,
  document,
  documentText,
  excelIcon,
  wordIcon,
  pdfIcon,
  emptyIcon,
  DashboardIcon,
  addImage,
  SearchNormal,
  add2,
};

export const alertIcons = {
  successAlert,
  activeAlert,
  errorAlert,
};

export const IconComponent = {
  DeleteIcon,
  CountFile,
  OpenIcon,
  UsedIcon,
  BalanceIcon,
  BudgetAllIcon,
};
export const IconComponents = {
  WebsiteIcon,
  UploadImageIcon,
  FolderActive,
  FolderInActive,
  ImageSelectIcon,
  CheckedIcon,
  MenuIcon,
  MenuIconActive,
  LinkIcon,
  FacebookIcon,
  XIcon,
  LineIcon,
  YoutubeIcon,
  InstagramIcon,
  HeartIcon,
  ViewIcon,
  SharedIcon,
  VdoIcon,
  LinksIcon,
  UploadImageFileIcon,
  SettingIcon,
  WebsiteRelatedIcon,
  WebsiteUserCommentIcon,
  SuggestionsIcon,
  FaqIcon,
  HeartSearchIcon,
  FacebookColorIcon,
  IGColorIcon,
  XColorIcon,
  YoutubeColorIcon,
  HeartNewsIcon,
  HeartNewsActiveIcon,
  EyeIcon,
  LineColorIcon,
  FlagEn,
  FlagTh,
  FilterSearchIcon
};
